<template>
  <div class="regpage">
    <div class="register">
      <div class="search">
        <img src="../../assets/images/search.png" alt class="searchpic" />
        <!-- <form action="" @submit="addfun"> -->
        <form>
          <input
            type="search"
            placeholder="搜索医生"
            class="searchinput"
            value
            v-model="keyword"
            @click="addfun"
          />
        </form>
      </div>
    </div>

    <div class="regcon">
      <div class="reg-left">
        <div class="wrapper w2" ref="wrapperleft">
          <div class="content">
            <div
              class="listyle"
              v-for="(item,index) in department"
              :key="index"
              :class="{'activeli':clicked==index}"
              v-on:click="changeTab(index,item.GUID)"
            >{{ item.Dpt_Name}}</div>
          </div>
        </div>
      </div>
      <div class="reg-right">
        <div class="wrapper" ref="wrapperright">
          <div class="content">
            <ul>
              <li class="regdetiel" v-for="item in doctors" :key="item.GUID" @click="jumpdetail(item.GUID)">
                <div class="pd20">
                  <span class="imgstyle">
                    <img :src="getDctImg(item.GUID)" />
                  </span>
                  <span class="Description">
                    <span class="regTitle">{{item.Name}}</span>
                    <span
                      class="docter"
                      v-bind:class="{ hidden: !item.Description }"
                    >{{item.Description}}</span>
                  </span>

                  <span class="spanfr">
                    <span
                      class="sourcebox"
                      :class="{sourcehas:item.BespeakNumber>0}"
                    >{{item.BespeakNumber | bespeakNumberFilters}}</span>
                  </span>
                </div>
                <div class="regdetielcon">
                  <p class="begoodat">擅长：{{item.Speciality}}</p>
                  <p class="bref">简介：{{item.Synopsis}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 无数据显示 -->
        <div class="noDate" v-show=false>
          <div>
            <img src="../../assets/images/searchbg.png" alt class="searchpic" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetRegDept, GetRegDctByDptID } from "@/services/getData.js";
import weui from "weui.js";
import _ from "lodash";
import BScroll from "better-scroll";
export default {
  name: "register-home",
  data() {
    return {
      clicked: 0,
      department: [],
      doctors: [],
      keyword: "",
      $dialog: [],
      imgUrl: config.configURL
    };
  },
  mounted() {
    this.$nextTick(() => {
      //$refs绑定元素
      if (!this.scroll) {
        // this.scroll = new BScroll(this.$refs.wrapperleft, {
        //   //开启点击事件 默认为false
        //   click: true
        // });
        this.scroll = new BScroll(this.$refs.wrapperright, {
          //开启点击事件 默认为false
          click: true
        });
        // console.log(this.scroll)
      } else if (!this.$refs.wrapper) {
        return;
      } else {
        this.scroll.refresh();
      }
    });
  },
  created: function() {
    var loading = weui.loading("loading", {
      className: "custom-classname",
      content: "加载中"
    });
    this.changeTab(0,"");
    loading.hide();
    GetRegDept().then(response => {
      loading.hide();
      var _that = this;
      if (response.data.Result) {
        this.department = response.data.Extend;
        if (this.department.length > 0) {
          this.changeTab(0, this.department[0].GUID);
        }
      } else {
        this.$dialog = weui.dialog({
          title: "提示",
          content: response.data.Content,
          buttons: [
            {
              label: "确定",
              type: "primary",
              onClick: function() {
                _that.$router.back(-1);
              }
            }
          ]
        });
      }
    });
  },
  destroyed: function() {
    if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
      this.$dialog.hide();
    }
  },
  methods: {
    getDctImg(id) {
      return config.configURL + "GetDctImg?id=" + id;
    },
    changeTab(index, dptID) {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      this.clicked = index;
      GetRegDctByDptID(dptID, this.keyword).then(response => {
        loading.hide();
        var orderbyData = _.orderBy(response.data, ["TitleLevel"], ["desc"]);
        this.doctors = response.data;
      });
    },
    addfun() {
      //跳转到搜索页
      this.$router.push({
        name: "RegisterSearch",
        params: { keyword: this.keyword }
      });
    },
    jumpdetail(doctorID) {
      //跳转到挂号详情页
      this.$router.push({
        name: "RegisterDetail",
        params: { doctorID: doctorID }
      });
    }
  },
  filters: {
    bespeakNumberFilters: function(value) {
      if (value > 0) {
        return "今日有号";
      } else {
        return "今日无号";
      }
    }
  }
};
</script>
<style>
.regpage {
  width: 100%;
  height: 100%;
}

.register {
  width: 100%;
  height: 0.8rem;
  padding: 0.14rem 0.2rem;
  background: white;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #dddddd;
  position: fixed;
  z-index: 2;
}

.regcon {
  width: 100%;
  height: 100%;
  display: flex;
}

.regpage .w2 {
  width: 2rem;
}

.search .searchinput {
  width: 100%;
  height: 0.5rem;
  font-size: 0.22rem;
  font-family: "MicrosoftYaHei";
  color: #999999;
  background-color: #f2f2f2;
  border-radius: 0.1rem;
  padding-left: 0.51rem;
  box-sizing: border-box;
}

.regpage .search {
  position: relative;
}

.regpage .search .searchpic {
  width: 0.22rem;
  height: 0.22rem;
  position: absolute;
  left: 0.16rem;
  top: 0.14rem;
}

.searchicon {
  position: absolute;
  width: 0.22rem;
  height: 0.22rem;
  top: 0.3rem;
  left: 0.3rem;
}

.regpage .regcon .reg-left {
  font-size: 0.22rem;
  color: #333333;
  flex: 0 0 2rem;
  width: 2rem;
  position: relative;
}

.regpage .listyle {
  width: 100% !important;
  line-height: 0.35rem !important;
  padding: 0.1rem;
  box-sizing: border-box;
  text-align: center;
}

.regcon .activeli {
  background-color: white;
  border-left: 0.06rem solid #3d97d1;
}

.regcon .reg-right {
  background-color: white;
  height: auto;
  flex: 1;
  position: relative;
}

.regcon .wrapper {
  /* width: 2rem; */
  position: absolute;
  top: 0.8rem;
  bottom: 0.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;
  width: 100%;
}

.regpage .regdetiel {
  /* padding:0.3rem 0; */
  margin-left: 0.2rem;
  border-bottom: 0.01rem dotted #dddddd;
  /* margin-right: 0.39rem; */
  margin-right: 0.2rem;
}

.regpage .regdetiel .imgstyle {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
}

.regpage .regdetiel .imgstyle > img {
  width: 0.75rem;
  height: 0.75rem;
}

.regpage .regdetiel .Description {
  display: inline-block;
  height: 0.75rem;
  margin-left: 0.1rem;
  position: relative;
  width: 1.5rem;
}

.regpage .regdetiel .regTitle {
  font-size: 0.26rem;
  color: #333333;
  display: inline-block;
  font-weight: 400;
  box-sizing: border-box;
  position: absolute;
  font-weight: 700;
  top: 0;
}

.regpage .regdetiel .spanfr {
  float: right;
}

.regpage .regdetiel .docter {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  background: rgba(61, 151, 209, 1);
  border-radius: 0.2rem;
  padding: 0.02rem 0.12rem;
  box-sizing: border-box;
  margin-right: 0.1rem;
  position: absolute;
  top: 0.45rem;
}

.regpage .sourcebox {
  font-size: 0.18rem;
  font-family: "MicrosoftYaHei";
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  display: inline-block;
  padding: 0.01rem;
  box-sizing: border-box;
  border: 0.01rem solid rgba(210, 210, 210, 1);
  border-radius: 0.02rem;
  text-align: center;
}

.regpage .sourcehas {
  color: #3d97d1 !important;
  border-color: #3d97d1 !important;
  margin-top: 0.2rem;
}

.regpage .regdetielcon {
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.36rem;
}

.begoodat {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.regpage .regdetielcon .bref {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0.3rem;
}

.hidden {
  display: none;
}

.regpage ul > li > div.pd20 {
  padding: 0.2rem 0;
  box-sizing: border-box;
  height: 1rem;
}

.regpage .noDate > div {
  font-size: 0.22rem;
  color: #999999;
  text-align: center;
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 50%;
  margin-top: -1.5rem;
  left: 50%;
  margin-left: -1.5rem;
}

.regpage .noDate > div > img {
  margin: 0 auto;
  width: 3rem;
  height: 2.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/register/register-home.vue